import { HttpStatusCode, isSome } from '@crocodille/common';
import * as Sentry from '@sentry/nextjs';
import NextErrorComponent, { ErrorProps as NextErrorProps } from 'next/error';

import { getAuthToken } from '../modules/auth';

import type { GetServerSidePropsContext } from 'next';
import NotFoundView from '../views/not-found-view/not-found-view';
import { getAppLayoutWithCart } from '@layouts/app-layout/app-layout';
import { AppPage } from '@framework/page';

const ErrorPage: AppPage<NextErrorProps> = ({ statusCode, title }) => {
  // If you're using a Nextjs version prior to 12.2.1, uncomment this to
  // compensate for https://github.com/vercel/next.js/issues/8592
  // Sentry.captureUnderscoreErrorException(props);

  if (statusCode === HttpStatusCode.NOT_FOUND) {
    return <NotFoundView />;
  }

  return <NextErrorComponent statusCode={statusCode} title={title} />;
};

ErrorPage.getLayout = (page) => {
  return getAppLayoutWithCart(page);
};

ErrorPage.getInitialProps = async (context) => {
  if (typeof window === 'undefined' && context.req) {
    const token = await getAuthToken({
      req: context.req as GetServerSidePropsContext['req'],
      res: context.res as GetServerSidePropsContext['res'],
    });

    if (isSome(token)) {
      Sentry.setUser({
        id: token.id,
        email: token.email ?? undefined,
      });
    }

    // In case this is running in a serverless function, await this in order to give Sentry
    // time to send the error before the lambda exits
    await Sentry.captureUnderscoreErrorException(context);
  }

  // APIError.extractTags(err);

  const nextErrorProps = await NextErrorComponent.getInitialProps(context);

  return nextErrorProps;
};

export default ErrorPage;
